/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerListProgramLocalizedTextDto } from '../models/EntityModelResponseContainerListProgramLocalizedTextDto';
import type { EntityModelResponseContainerProgramLocalizedTextDto } from '../models/EntityModelResponseContainerProgramLocalizedTextDto';
import type { PagedModelEntityModelProgramLocalizedTextDto } from '../models/PagedModelEntityModelProgramLocalizedTextDto';
import type { PagedResourcesAssemblerProgramLocalizedTextDto } from '../models/PagedResourcesAssemblerProgramLocalizedTextDto';
import type { ProgramLocalizedTextDto } from '../models/ProgramLocalizedTextDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProgramDynamicLocalizedTextControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static createOrUpdateBulk({
        requestBody,
    }: {
        requestBody: Array<ProgramLocalizedTextDto>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/localizedTextsBulkUpdate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PagedModelEntityModelProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        keyStartsWith,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerProgramLocalizedTextDto,
        keyStartsWith?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/texts',
            query: {
                'keyStartsWith': keyStartsWith,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        languageCode,
        messageKey,
    }: {
        languageCode: string,
        messageKey: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static read({
        languageCode,
        messageKey,
    }: {
        languageCode: string,
        messageKey: string,
    }): CancelablePromise<EntityModelResponseContainerProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static create({
        languageCode,
        messageKey,
        requestBody,
    }: {
        languageCode: string,
        messageKey: string,
        requestBody: ProgramLocalizedTextDto,
    }): CancelablePromise<EntityModelResponseContainerProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static update({
        languageCode,
        messageKey,
        requestBody,
    }: {
        languageCode: string,
        messageKey: string,
        requestBody: ProgramLocalizedTextDto,
    }): CancelablePromise<EntityModelResponseContainerProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getFixedLockMessages(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/texts/fixed-lock-messages',
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramLocalizedTextDto<any> OK
     * @throws ApiError
     */
    public static readMultiple({
        messageKeys,
    }: {
        messageKeys: Array<string>,
    }): CancelablePromise<EntityModelResponseContainerProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/texts/keys/readMultiple',
            query: {
                'messageKeys': messageKeys,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerListProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static readBulk({
        messageKey,
    }: {
        messageKey: string,
    }): CancelablePromise<EntityModelResponseContainerListProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/texts/keys/{messageKey}',
            path: {
                'messageKey': messageKey,
            },
        });
    }
}
